import qs from 'qs'
import Drops from '../../components/drops/Drops'
import { get } from '../../components/helpers/Api'

const MarketPage = (props) => {
    return <Drops {...props} />
}

MarketPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    const values = qs.parse(paths[paths.length - 1].replace('drops?', ''))

    values['search_page'] = false
    values['searchType'] = values['search_type']
        ? values['search_type']
        : 'sales'
    values['tab'] = values['tab'] ? values['tab'] : 'drops'

    if (values['collection'] && values['collection'] !== '*')
        values['collection_details'] = await get(
            'collection-minimal/' + values['collection'],
            'legacy',
        )

    return values
}

export default MarketPage
